import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Globe2, Megaphone } from "lucide-react";

export default function GovBar() {
  const [announcements, setAnnouncements] = useState([]);

  const fetch = () => api.get("/announcements").then((r) => setAnnouncements(r.data)).catch(() => setAnnouncements([]));
  useEffect(() => {
    fetch();
    const i = setInterval(fetch, 30000);
    const onVis = () => { if (document.visibilityState === "visible") fetch(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(i); document.removeEventListener("visibilitychange", onVis); };
  }, []);

  const items = announcements.length
    ? announcements
    : [{ id: "1", text: "Welcome to the Official Portal of National Karate Federation - NKF Bharat" }];
  return (
    <div
      data-testid="gov-bar"
      className="w-full bg-nkf-navy text-white text-xs md:text-[13px] border-b border-nkf-gold/20"
    >
      <div className="nkf-container flex items-center justify-between gap-4 py-1.5">
        <div className="flex items-center gap-2 min-w-0 flex-1 overflow-hidden">
          <Megaphone className="h-3.5 w-3.5 text-nkf-gold shrink-0 animate-pulse" />
          <div className="relative overflow-hidden flex-1 group">
            <div className="marquee-track animate-marquee group-hover:[animation-play-state:paused]">
              {[...items, ...items].map((a, idx) => (
                <a
                  key={idx}
                  href={a.link || "/news"}
                  className="px-6 inline-flex items-center gap-2 hover:text-nkf-gold transition"
                >
                  <span className="text-nkf-gold/80">●</span>
                  <span className="text-white/90 hover:text-nkf-gold">{a.text}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-4 shrink-0">
          <a href="/downloads" className="hover:text-nkf-gold transition" data-testid="gov-bar-circulars">Circulars</a>
          <a href="/news" className="hover:text-nkf-gold transition" data-testid="gov-bar-notifications">Notifications</a>
          <span className="inline-flex items-center gap-1 text-white/80">
            <Globe2 className="h-3.5 w-3.5" /> EN
          </span>
        </div>
      </div>
    </div>
  );
}
